import { PropsWithChildren } from "react";
import { motion, Variants } from "motion/react";

export default function DrawerAnimated(
  p: PropsWithChildren<{
    open?: boolean;
    className?: string;
  }>,
) {
  const variants: Variants = {
    visible: {
      marginLeft: 0,
      visibility: "visible",
      transition: {
        duration: 0.1,
        ease: "easeOut",
      },
    },
    hidden: {
      marginLeft: -20,
      transitionEnd: {
        visibility: "collapse",
      },
      transition: {
        duration: 0.1,
        ease: "easeIn",
      },
      width: 0,
    },
  };

  return (
    <motion.div
      initial="visible"
      animate={p.open ? "visible" : "hidden"}
      variants={variants}
      className={p.className}
    >
      {p.children}
    </motion.div>
  );
}
